const isBreadcrumb = breadcrumbs => {
    if (breadcrumbs === undefined) {
        return undefined;
    }
    else {
        return breadcrumbs.Breadcrumb;
    }
}

export default isBreadcrumb;
